// extracted by mini-css-extract-plugin
module.exports = {"search-box":"Q_fD","search-box__input":"Q_fF form-control","search-box__icon":"Q_fG ml-2"};